


















import Vue from "vue";
import dialog from "@/common/mixins/dialog";
import { required } from "vuelidate/lib/validators";
export default Vue.extend({
  mixins: [dialog],
  validations: {
    mcNumber: { required }
  },
  data() {
    const mcNumber = "";
    return {
      mcNumber
    };
  },
  methods: {
    async holdOrder() {
      try {
        const {
          data
        } = await (this as any).$dep.orderUseCase.holdOrderByMcnumber(
          this.mcNumber
        );
        (this as any).alertSuccess("Success", "Hold Order สำเร็จ");
        this.mcNumber = "";
      } catch (error) {
        if (error.response.data.message) {
          (this as any).alertError("Error", error.response.data.message);
        } else {
          (this as any).alertError("Error", error);
        }
      }
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;
      const isConfirmed = await (this as any).alertConfirm(
        "Confirm to hold order" + this.mcNumber,
        "คุณต้องการพัก order: " + this.mcNumber + " ชั่วคราวหรือไม่ ?"
      );
      if (isConfirmed) {
        await this.holdOrder();
      }
    }
  }
});
